import { render, staticRenderFns } from "./PasoCincoComponent.vue?vue&type=template&id=1f51c61d"
import script from "./PasoCincoComponent.vue?vue&type=script&lang=js"
export * from "./PasoCincoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports